import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=231bc9bc&scoped=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"
import style0 from "./Order.vue?vue&type=style&index=0&id=231bc9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bc9bc",
  null
  
)

export default component.exports